import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import TextInput from '../text-input/TextInput';

export default class LinkInput extends Component {

  constructor(props) {
    super(props);

    // Set the state for the object containing linkText & linkURL values
    this.state = {
      existingContentObject: this.props.existingContentObject
    };
  }

  getValue = () => {

    if (this.props.isEditable) {

      // creates an object to hold the updated values
      let newLinkContentObject = {};

      // connects the LinkInput values to the new object
      newLinkContentObject["linkText"] = this[`${this.props.id}__link-text`].getValue();
      newLinkContentObject["linkURL"] = this[`${this.props.id}__link-URL`].getValue();

      // updates the object in state with the new values
      this.setState({ existingContentObject: newLinkContentObject })

      return newLinkContentObject;
    }

    return this.state.existingContentObject;

  }

  render() {

    const label = this.props.label ?
      <label htmlFor={this.props.id}>
        {this.props.label}
      </label> :
      null;

    let requiredFieldIndicator = (this.props.required) ?
      <abbr title="This field is required"></abbr> :
      null;

    const errorMessage = this.props.errorMessage ?
      <span className="error-message">
        {this.props.errorMessage}
      </span> :
      null;

    let link = (this.props.newWindow) ?
      <a
        className="read-only"
        href={this.state.existingContentObject["linkURL"]}
        target="_blank"
        rel="noopener noreferrer"
      >
        {this.state.existingContentObject["linkText"]}
      </a> :
      <Link
        className="read-only"
        to={this.state.existingContentObject["linkURL"]}
      >
        {this.state.existingContentObject["linkText"]}
      </Link>;

    let linkContent = this.props.isEditable ?

      // Displays form fields for editing
      <span>
        <fieldset id={this.props.id} disabled={this.props.disabled} className={`field__group link-input ${this.props.verticalSpacing}`}>
          {this.props.label ? <legend>{this.props.label}{requiredFieldIndicator}</legend> : null}
          <TextInput
            id={`${this.props.id}__link-text`}
            label="Link Text"
            className="field__large"
            placeholderText="Enter the text to link here."
            existingContent={this.state.existingContentObject["linkText"]}
            ref={instance => { this[`${this.props.id}__link-text`] = instance; }}
            verticalSpacing={this.props.verticalSpacing}
          />
          <TextInput
            id={`${this.props.id}__link-URL`}
            label="Link URL"
            className="field__full-width"
            placeholderText="For example: http://ccf.org"
            existingContent={this.state.existingContentObject["linkURL"]}
            ref={instance => { this[`${this.props.id}__link-URL`] = instance; }}
            verticalSpacing={this.props.verticalSpacing}
          />
        </fieldset>
        {errorMessage}
      </span> :

      // Displays a "Read-only" link with optional label
      <span>
        {this.props.label ? <label>{this.props.label}</label> : null}
        {link}
      </span>
      ;

    return linkContent;
  }
}

LinkInput.defaultProps = {
  newWindow: true,
  isEditable: false
};

LinkInput.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  errorMessage: PropTypes.string,
  existingContentObject: PropTypes.shape({
    linkText: PropTypes.string,
    linkURL: PropTypes.string
  }),
  id: PropTypes.string,
  isEditable: PropTypes.bool,
  label: PropTypes.string,
  newWindow: PropTypes.bool,
  required: PropTypes.bool,
  verticalSpacing: PropTypes.string
};
